import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
import { Skeleton } from "../../../skeleton/src";
import { FONT_BRIGHTNESS } from "../../../theme/src";
export const ContentRecommendationItemSkeleton = () => (_jsxs(Wrapper, { "data-testid": "content-recommendation-item-skeleton", mb: 5, children: [_jsx(Skeleton, { height: { _: '128px', m: '69px' }, width: { m: '186px' } }), _jsxs(Box, { flex: 1, flexDirection: "column", ml: { m: 6 }, p: { _: 4, m: 0 }, children: [_jsx(Skeleton, { height: 20, width: 60 }), _jsx(Skeleton, { height: 20, mb: 1, mt: 2, width: "70%" }), _jsx(Skeleton, { height: 20, width: "100%" })] })] }));
const Wrapper = styled(Box).attrs({
    p: { _: 0, m: 4 },
    minHeight: { _: '163px', m: '145px' },
    flexDirection: { _: 'column', m: 'row' },
    alignItems: { m: 'center' },
    justifyContent: { m: 'center' },
}) `
  border: 1px solid
    ${({ theme }) => {
    if (theme.themeVariables.fontBrightness === FONT_BRIGHTNESS.LIGHT) {
        return theme.colors.snow;
    }
    return theme.colors.horizon;
}};
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
`;
//# sourceMappingURL=ContentRecommendationItemSkeleton.js.map